import { render, staticRenderFns } from "./CheckboxColoredTable.vue?vue&type=template&id=4d012527&"
import script from "./CheckboxColoredTable.vue?vue&type=script&lang=js&"
export * from "./CheckboxColoredTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports